import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    SettingOption,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';

export default class SNMP extends BaseFeature {
    constructor() {
        super();
        this.name = 'SNMP';
        this.id = 'snmp';
        this.files = [
            'libraries/snmp/snmp.tbh',
            'libraries/snmp/snmp.tbs',
        ];

        const settings = [
            {
                id: 'ENABLED',
                name: 'Enabled',
                settingType: SettingType.OPTION,
                required: true,
                default: '0',
                options: [
                    {
                        name: 'Disabled',
                        value: '0',
                    },
                    {
                        name: 'Enabled',
                        value: '1',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getDefines(): Define[] {
        return [
            {
                name: 'SNMP_INTERFACE_COUNT_VALUE',
                value: '7',
            },
            {
                name: 'SNMP_TIBBO_SLOT_COUNT_VALUE',
                value: '6',
            },
            {
                name: 'SNMP_TIBBO_PIN_COUNT_VALUE',
                value: '24',
            },
            {
                name: 'SNMP_SET_DESCRIPTION',
                value: '"Tibbo"',
            },
            {
                name: 'SNMP_SET_SYSNAME',
                value: '"Tibbo"',
            },
        ];
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];
        const project: ProjectConfiguration = this.project;
        if (this.getSettingValue('ENABLED').toString() === '0') {
            return blocks;
        }

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    if snmp_initialize("public","","") = true then
        sock_snmp = sock_get("SNMP")
        sock.num = sock_snmp
        sock.protocol = PL_SOCK_PROTOCOL_UDP
        sock.localportlist = "161"
        sock.connectiontout = 600
        sock.allowedinterfaces = "NET,WLN"
        sock.inconmode = PL_SOCK_INCONMODE_ANY_IP_ANY_PORT
        sock.reconmode = PL_SOCK_RECONMODE_3
        sock.txbuffrq(1)
        sock.rxbuffrq(1)
        sys.buffalloc

        if traps_enable = true then
            sock_trap = sock_get("SNMT")
            sock.num = sock_trap
            sock.protocol = PL_SOCK_PROTOCOL_UDP
            sock.targetport = "162"
            sock.targetip = trap_receiver
            sock.connectiontout = 600
            sock.allowedinterfaces = "NET,WLN"
            sock.reconmode = PL_SOCK_RECONMODE_3
            sock.txbuffrq(1)
            sock.rxbuffrq(1)
            sys.buffalloc
        end if

        #if DEV_DEBUG_PRINT
            dev_debugprint("SNMP initialized")
        #endif
    end if
        `,
        });

        blocks.push({
            location: 'on_sock_data_arrival',
            blockType: BlockType.CODE,
            template: `
    if sock.num = sock_snmp then
        snmp_receive(sock.getdata(255))
    end if`,
        });


        return blocks;
    }
}
